import RowSelectionModel from './slick.rowselectionmodel';
export default RowSelectionModel;
